import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Avatar, IconButton, Menu, MenuItem, Typography, Divider, ListItemIcon
} from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../context/AuthContext';

export default function UserAvatarMenu() {
  const { user, isAdmin, authMode, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const getInitials = () => {
    if (authMode === 'bypass') return 'DEV';
    if (!user?.displayName) return user?.email?.[0]?.toUpperCase() || '?';
    return user.displayName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  const handleAdmin = () => {
    handleClose();
    navigate('/admin/users');
  };

  const handleLogout = async () => {
    handleClose();
    await logout();
    navigate('/login');
  };

  return (
    <>
      <IconButton onClick={handleOpen} size="small">
        <Avatar
          sx={{
            width: 32, height: 32, fontSize: 12,
            bgcolor: authMode === 'bypass' ? 'warning.main' : 'primary.main'
          }}
        >
          {getInitials()}
        </Avatar>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{ sx: { minWidth: 200, mt: 1 } }}
      >
        <MenuItem disabled sx={{ opacity: '1 !important' }}>
          <div>
            <Typography variant="body2" fontWeight={600}>
              {user?.displayName || 'Unknown User'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {user?.email || ''}
              {authMode === 'bypass' && ' (Dev Mode)'}
            </Typography>
          </div>
        </MenuItem>

        <Divider />

        {isAdmin && (
          <MenuItem onClick={handleAdmin}>
            <ListItemIcon><AdminPanelSettingsIcon fontSize="small" /></ListItemIcon>
            Admin Panel
          </MenuItem>
        )}

        {authMode !== 'bypass' && (
          <MenuItem onClick={handleLogout}>
            <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
            Logout
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
